import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { CustomList } from "components";
import { HoursCell, TotalHoursCell } from "@/components/hours/cell";
import { useJob } from "@/modules/work/jobs/context";
import JobTimesheetDepartmentFilters from "./filters";

export default function JobbTimesheetDepartments() {
  const [totals, setTotals] = useState(null);
  const { jobId } = useParams();
  const { project, type } = useJob();

  const isFixedOrDedicated = ["fixed", "dedicated"].includes(type);

  const isHourlyOrBucket = ["hourly", "bucket"].includes(type);

  const columns = [
    {
      header: "Department",
      accessorKey: "department.name",
      footer: "Total",
    },
    ...(isFixedOrDedicated
      ? [
        {
          header: "Grade",
          accessorKey: "grade.name",
        },
      ]
      : []),
    ...(isFixedOrDedicated
      ? [
        {
          id: "allocated_hours",
          accessorKey: "allocated_hours",
          header: "Allocated",
          cell: HoursCell,
          footer: TotalHoursCell("allocated_hours"),
        },
      ]
      : []),
    ...(isFixedOrDedicated
      ? [
        {
          id: "consumed_hours",
          accessorKey: "consumed_hours",
          header: "Consumed",
          cell: HoursCell,
          footer: TotalHoursCell("consumed_hours"),
        },
      ]
      : []),
    {
      id: "approved_hours",
      accessorKey: "approved_hours",
      header: "Approved",
      cell: HoursCell,
      footer: TotalHoursCell("approved_hours"),
    },
    ...(isFixedOrDedicated
      ? [
        {
          id: "spent_hours",
          accessorKey: "spent_hours",
          header: "Spent",
          cell: HoursCell,
          footer: TotalHoursCell("spent_hours"),
        },
      ]
      : []),
    {
      id: "logged_hours",
      accessorKey: "logged_hours",
      header: "Logged",
      cell: HoursCell,
      footer: TotalHoursCell("logged_hours"),
    },
    ...(isHourlyOrBucket
      ? [
        {
          id: "billable_hours",
          accessorKey: "billable_hours",
          header: "Billable",
          cell: HoursCell,
          footer: TotalHoursCell("billable_hours"),
        },
      ]
      : []),
    {
      id: "unapproved_hours",
      accessorKey: "unapproved_hours",
      header: "Unapproved",
      cell: HoursCell,
      footer: TotalHoursCell("unapproved_hours"),
    },
    {
      id: "unreviewed_hours",
      accessorKey: "unreviewed_hours",
      header: "Unreviewed",
      cell: HoursCell,
      footer: TotalHoursCell("unreviewed_hours"),
    },
  ];

  const defaultFilters = {
    jobId,
    projectId: project.id,
  };

  return (
    <div className=" flex-1 overflow-auto" key={defaultFilters}>
      <CustomList
        title="Departments"
        storageKey={`${jobId}-${project.id}-departments`}
        endPoint="custom-ui/get-department-wise-timesheet-summary-for-project"
        filters={defaultFilters}
        columns={columns}
        hidePagination={true}
        onDataChange={(response) => setTotals(response.meta?.totals)}
        renderFilters={JobTimesheetDepartmentFilters}
        teleportFilters={true}
        getRowClassName={(row) =>
          row?.has_allocation === false || row?.is_allocated === false
            ? "bg-red-50 hover:bg-red-100/60"
            : ""
        }
      />
    </div>
  );
}
